import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectUpdateMyDocumentsListParentFolderId,
  selectUpdateMyDocumentsListSubjectId,
  setUpdateMyDocumentsList,
} from 'reducers/misc';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { Spinner } from 'components/spinner/Spinner';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import FormTextField from 'components/formComponents/FormTextField';
import * as Yup from 'yup';
import { endpoints } from 'endpoints.config';
import { MyDocumentsApi } from 'api/myDocumentsApi';
import { ErrorM } from 'components/formComponents/ErrorM';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedId?: number;
  folderId?: number | null;
  callback?: (params: { id: number | null; name: string }) => void;
};

const getConfig = (selectedId: number | undefined, subjectsId: number) => {
  return selectedId
    ? {
        url: endpoints.myDocuments.updateFolder,
        params: {
          subjectsId: subjectsId,
          folderId: selectedId,
        },
        title: 'Edit folder',
      }
    : {
        url: `${endpoints.myDocuments.createFolder}`,
        params: {
          subjectsId: subjectsId,
        },
        title: 'Create folder',
      };
};

export const CreateFolder: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  selectedId,
  folderId,
  callback,
}) => {
  const updateListSubjectId: any = useSelector(
    selectUpdateMyDocumentsListSubjectId
  );

  const updateListParentFoldersId: any = useSelector(
    selectUpdateMyDocumentsListParentFolderId
  );

  const formikRef = React.useRef<FormikProps<any>>(null);

  const config = getConfig(selectedId, updateListSubjectId);

  const dispatch = useDispatch();

  // const { loading, data, error } = useFetch(
  //   config.url,
  //   {
  //     params: config.params,
  //   },
  //   undefined,
  //   selectedId !== undefined
  // );

  const validationSchema = Yup.object({
    folderName: Yup.string().required('Folder name is required'),
  });

  const submitForm = async (values: any, formikProps: FormikHelpers<any>) => {
    try {
      const result = await MyDocumentsApi.createEditFolder(config.url, values);

      if (result.data && result.data.status === '1') {
        !callback && dispatch(setUpdateMyDocumentsList(true));
        callback && callback({ id: result.data.id, name: values.folderName });
        togglePanelOpen(false);
      }

      if (result.data && result.data.errors) {
        formikProps.setFieldError('name', result.data.errors[0].message);
      }
      if (result.error) {
        formikProps.setFieldError('genericError', result.error);
      }
    } catch (error) {
      formikProps.setFieldError('genericError', 'An error occurred');
    } finally {
      formikProps.setSubmitting(false);
    }
  };

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={config.title}
      position="right"
      setTop={true}
      noBackground={true}
      noHeader={true}
      noContentContainer={true}
      givenClass="DocumentHandlePage"
      noFooter={true}
      handleClose={() => togglePanelOpen(false)}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
      isSubmitting={formikRef.current?.isSubmitting}
      noOverflowToggle={true}
    >
      <Formik
        innerRef={formikRef}
        initialValues={{
          folderName: '',
          subjectsId: updateListSubjectId,
          parentFoldersId: folderId ? folderId : updateListParentFoldersId,
        }}
        onSubmit={submitForm}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <div className="WidthContent">
              <span className="BtnBack" onClick={() => togglePanelOpen(false)}>
                <span className="BB_Icon"></span>
                <span className="BB_Txt">Back</span>
              </span>

              <div className="DHPageContent">
                <h2>Create folder</h2>
                <div
                  className={
                    'DocDetailsRow' + (isSubmitting ? ' DisableDocForm' : '')
                  }
                >
                  <div className="DocDRInner">
                    <div className={'DocRowBlock'}>
                      <FormTextField
                        label="Folder name"
                        field="folderName"
                        required={true}
                        labelPosition="left"
                        value={values.name}
                        placeholder="Folder name"
                      />
                      <ErrorM name="genericError" />
                    </div>
                  </div>
                </div>

                <div
                  className="Btn BtnOrange DocFormSubmitBtn"
                  onClick={() => submitForm()}
                >
                  Save
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      {formikRef.current?.isSubmitting && <Spinner />}
    </PopupOrPanel>
  );
};
